export enum FlexAlign {
  left = 'align-items-start',
  center = 'align-items-center',
  right = 'align-items-end'
}
